import { newSize, newTextPinComponent, newVector, fallbackCopy } from '../helpers';
import { WordCloudPinLayoutTemplate } from '../models';
import { stringToProsemirror } from '../tip-tap';

export function wordCloudTitleOnlyLayout({
  question = fallbackCopy['wordCloud.title'],
  backgroundColor,
  bold = true,
  textPinComponentSettings = {},
  pinComponentPosition = newVector(32, 240),
  pinComponentSize = newSize(896, 60),
  backgroundImage,
}: {
  question?: string;
  backgroundColor?: string;
  bold?: boolean;
  textPinComponentSettings?: Parameters<typeof newTextPinComponent>[0]['settings'];
  pinComponentPosition?: Parameters<typeof newTextPinComponent>[0]['position'];
  pinComponentSize?: Parameters<typeof newTextPinComponent>[0]['size'];
  backgroundImage?: string;
}): WordCloudPinLayoutTemplate {
  return {
    key: 'TITLE_ONLY',
    backgroundColor,
    backgroundImage,
    pinComponents: [],
    layoutParts: {
      TITLE: newTextPinComponent({
        position: pinComponentPosition,
        size: pinComponentSize,
        content: stringToProsemirror(question, {
          bold,
        }),
        order: 'a0',
        settings: {
          typographyKey: 'headline',
          textStyleKey: 'TITLE',
          horizontalAlignment: 'center',
          ...textPinComponentSettings,
        },
      }),
    },
  };
}
